import { render, staticRenderFns } from "./SetGroupSeatForm.vue?vue&type=template&id=a8c00220&scoped=true&"
import script from "./SetGroupSeatForm.vue?vue&type=script&lang=js&"
export * from "./SetGroupSeatForm.vue?vue&type=script&lang=js&"
import style0 from "./SetGroupSeatForm.vue?vue&type=style&index=0&id=a8c00220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c00220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8c00220')) {
      api.createRecord('a8c00220', component.options)
    } else {
      api.reload('a8c00220', component.options)
    }
    module.hot.accept("./SetGroupSeatForm.vue?vue&type=template&id=a8c00220&scoped=true&", function () {
      api.rerender('a8c00220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/modules/SetGroupSeatForm.vue"
export default component.exports